import styled from 'styled-components';

const PrimaryButton = styled.button`
	width: 100%;
	height: 40px;
	border-radius: 8px;
	border: none;
	font-size: 14px;
	font-weight: 400;
	cursor: pointer;
	transition: background-color 0.2s, opacity 0.2s;
	background-color: #5B7FFF !important;
	color: #FFF !important;
	margin-top: 8px !important;

	&:hover:not(:disabled) {
		background-color: #4A6FEE !important;
	}

	&:disabled {
		background-color: #D9E1E8 !important;
		color: #9CA3AB !important;
		cursor: not-allowed;
	}
`;

export default PrimaryButton;
